<template>
    <v-row>
        <v-col cols="auto" align-self="center">
            <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="SignIn(autoImportConfig)"
                >
                <v-icon dark>mdi-account-key-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ autoImportConfig.emailAccount }}</span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto" align-self="center">
            <v-tooltip top v-if="!loading">
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="showTreeViewFolders(autoImportConfig)"
                >
                <v-icon dark>mdi-file-tree-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ $t("Site.ContentType.AutoImportConfig.SelectFolder") }}</span>
            </v-tooltip>
        </v-col>
        <v-col cols="1" sm="1" md="1" align-self="center" v-if="loading">
            <v-progress-circular
            :size="20"
            :width="3"
            color="primary"
            indeterminate
            class="align-center"
            ></v-progress-circular>
        </v-col>
        <v-col cols="12" sm="4" md="6" align-self="center">
            <v-text-field
            v-model="autoImportConfig.nameFolder"
            :disabled="true"
            :loading="loading"
            v-bind:label="$t('RootFolder')"
            :error-messages="folderErrors()"
            />
        </v-col>
        <v-col cols="1" sm="1" md="1" align-self="center" v-if="loading">
            <v-progress-circular
            :size="20"
            :width="3"
            color="primary"
            indeterminate
            class="align-center"
            ></v-progress-circular>
        </v-col>
        <v-col
            cols="auto"
            align-self="center"
            v-if="!loading"
        >
            <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="createFolder(autoImportConfig)"
                :disabled="autoImportConfig.folderList.length == 0"
                >
                <v-icon dark>mdi-folder-plus-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ $t("CreateFolder") }}</span>
            </v-tooltip>
        </v-col>

        <ContentTypeAutoImportConfigModalCreateFolder
            :ref="folderModalKey"
            :serviceId="autoImportConfig.serviceID"
            @on-saved="onFolderCreated"
        />

        <TreeViewFoldersModal
            :ref="treeViewFoldersModalKey"
            :treeItems="treeItems"
            :token="authToken"
            @on-folder-selected="onFolderSelected"
        />
    </v-row>
</template>
<script>
import ContentTypeAutoImportConfigModalCreateFolder from '@/components/administration/contentType/autoImport/ContentTypeAutoImportConfigModalCreateFolder';
import CloudDriveService from '@/services/CloudDriveService';
import Utils from '@/ecm/common/Utils';
import TreeViewFoldersModal from '@/components/administration/contentType/autoImport/TreeViewFoldersModal.vue';
import GoogleCloudService from '@/services/GoogleCloudService';

export default {
    name: 'CloudProvidersConfig',
    components: {
        ContentTypeAutoImportConfigModalCreateFolder,
        TreeViewFoldersModal
    },
    props: {
        validator: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        }
    },
    created() {
        this.getFoldersFromConfigs();
    },
    watch: {
        loading(newVal) {
            this.$emit('update-loading', newVal);
        }
    },
    data() {
        return {
            autoImportConfig: this.item,
            loading: false,
            folderModalKey: 'folderModalKey',
            treeViewFoldersModalKey: 'treeViewFoldersModalKey',
            treeItems: [],
            authToken: {},
        };
    },
    methods: {
        folderErrors() {
            const errors = [];
            if (!this.validator.rootFolder.$dirty) return errors;
            if (!this.validator.rootFolder.required) {
                errors.push(this.$t('RequiredField'));
            }
            return errors;
        },
        async SignIn(item) {
            const token = await this.PerformCloudStorageSignIn();
            if (token) {
                this.loading = true;
                item.oAuthAccessToken = this.authToken.AccessToken;
                item.oAuthRefreshToken = this.authToken.RefreshToken;
                const getFoldersRequest = {
                    RefreshToken: this.authToken.RefreshToken,
                    DocECMContentTypeAutoImportConfigService: item.serviceID,
                };
                const foldersResponse = await CloudDriveService.getFolders(getFoldersRequest);
                item.folderList = foldersResponse.folders;
                this.treeItems = item.folderList.map(folder => ({
                    id: folder.id,
                    text: folder.text,
                    ...(folder.hasChildren ? { children: [] } : {})
                }));
                item.rootFolder = '';
                const userEmailRequest = {
                    RefreshToken: this.authToken.RefreshToken,
                    DocECMContentTypeAutoImportConfigService: item.serviceID
                };
                const userEmail = await CloudDriveService.getUserEmail(userEmailRequest);
                item.emailAccount = userEmail.email;
                this.loading = false;
            }
        },
        async PerformCloudStorageSignIn() {
            let token = null;
            const data = await GoogleCloudService.getGoogleCloudOAuthUrl();
            var googleCloudLoginWindow = window.open(data.oAuthUrl, 'resizable=yes,status=yes,location=yes');
            token = await GoogleCloudService.getGoogleCloudToken();
            this.authToken = {
                AccessToken: token.accessToken,
                RefreshToken: token.refreshToken,
            };
            googleCloudLoginWindow.close();
            return token;
        },
        getFoldersFromConfigs() {
            if (this.autoImportConfig.oAuthRefreshToken != '') {
                this.autoImportConfig.folderList = [];
                const token = {
                    RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                    AccessToken: null,
                };
                this.authToken = token;
                this.loading = true;
                const getFoldersRequest = {
                    RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                    DocECMContentTypeAutoImportConfigService: this.autoImportConfig.serviceID,
                };
                CloudDriveService.getFolders(getFoldersRequest)
                    .then((data) => {
                        this.autoImportConfig.folderList = data.folders;
                        this.treeItems = this.autoImportConfig.folderList.map(folder => ({
                            id: folder.id,
                            text: folder.text,
                            ...(folder.hasChildren ? { children: [] } : {})
                        }));
                        this.loading = false;

                        if (this.autoImportConfig.rootFolder !== '') {
                            this.loading = true;
                            const folderNameRequest = {
                                RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                                FolderId: this.autoImportConfig.rootFolder,
                                DocECMContentTypeAutoImportConfigService: this.autoImportConfig.serviceID
                            };
                            CloudDriveService.getFolderName(folderNameRequest)
                                .then((folderName) => {
                                    this.autoImportConfig.nameFolder = folderName.folderName;
                                    this.loading = false;
                                });
                        }
                    });
            }
        },
        createFolder(item) {
            this.$refs[this.folderModalKey].show(item.oAuthRefreshToken);
        },
        onFolderCreated() {
            Utils.toast.success(this.$t('SavedSuccessfully'));
            this.getFoldersFromConfigs();
        },
        onFolderSelected(folder) {
            this.autoImportConfig.rootFolder = folder.id;
            this.autoImportConfig.nameFolder = folder.text;
            this.$emit('on-folder-selected', this.autoImportConfig);
        },
        showTreeViewFolders(item) {
            const itemID = item.id > 0 ? item.id : item.uuid;
            this.$refs[this.treeViewFoldersModalKey].show(itemID, item.serviceID);
        },
    }
};
</script>